export default __webpack_public_path__ + "static/media/GoodToon.a4d317fc.png";